<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          label="List page"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          label="Search"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>

    <b-row class="match-height mt-1 mb-4">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <Alert
          :show="showFormErrorAlert"
          message="Customer's account name or account number or reference number is required"
        />

        <b-row>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              label="Account Number"
              placeholder="Enter account number"
              type="number"
              error-name="Account Number"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              label="Account Name"
              placeholder="Enter account name"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              label="Reference Number"
              placeholder="Enter reference number"
              type="number"
              error-name="Reference Number"
              rules=""
            />
          </b-col>
        </b-row>

        <Button
          label="Search"
          size="md"
          class="mt-2"
          block
          @click="handleSearch"
        />
      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="overdraftRules">
            <b-form @submit.prevent="handleSubmit">
              <app-collapse
                class="business-items mb-4"
                type="margin"
                accordion
              >
                <app-collapse-item
                  title="Account Information"
                  class="card-item"
                  is-visible
                >
                  <b-row class="match-height">
                    <!-- Account Name -->
                    <b-col md="4">
                      <InputField
                        id="account-name"
                        v-model="accountInfo.accountName"
                        label="Account Name"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Account Name -->

                    <!-- Product Name -->
                    <b-col md="4">
                      <InputField
                        id="product-name"
                        v-model="accountInfo.productName"
                        label="Product Name"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Product Name -->

                    <!-- Account Number -->
                    <b-col md="4">
                      <InputField
                        id="account-number"
                        v-model="overdraftFormData.accountNumber"
                        label="Account Number"
                        type="number"
                        readonly
                      />
                    </b-col>
                    <!--  Account Number -->

                    <!-- Ledger Balance -->
                    <b-col md="4">
                      <InputField
                        id="ledger-balance"
                        v-model="customer.ledgerBalance"
                        label="Ledger Balance"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Ledger Balance -->

                    <!-- Available Balance -->
                    <b-col md="4">
                      <InputField
                        id="available-balance"
                        v-model="customer.availableBalance"
                        label="Available Balance"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Available Balance -->

                    <!-- Withdrawal Balance -->
                    <b-col md="4">
                      <InputField
                        id="withdrawable-Balance"
                        v-model="customer.withdrawableBalance"
                        label="Withdrawal Balance"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Withdrawal Balance -->
                  </b-row>
                </app-collapse-item>
              </app-collapse>

              <h5 class="text-capitalize mb-3">
                Overdraft Details
              </h5>
              <b-row class="match-height">
                <!--Overdraft Limit-->
                <b-col md="6">
                  <InputNumberField
                    id="overdraft-limit"
                    v-model.number="overdraftFormData.limit"
                    label="Overdraft Limit"
                    error-name="overdraft Limit"
                    rules="required|positive"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Overdraft Limit -->

                <!-- Tenure -->
                <b-col md="6">
                  <InputNumberField
                    id="tenure"
                    v-model="overdraftFormData.tenure"
                    label="Tenure (Days)"
                    :on-input="setEndDateValue"
                    error-name="Tenure"
                    rules="required|integer|positive"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Tenure -->

                <!-- Start Date-->
                <b-col md="6">
                  <DatePickerField
                    id="start-date"
                    v-model="overdraftFormData.commencementDate"
                    rules="required"
                    label="Start Date"
                    error-name="Start Date"
                    :on-change="setEndDate"
                    :config="datePickerConfig"
                    placeholder="Select Date"
                    :disabled="isReadonly"
                  />
                </b-col>
                <!--  Start Date -->

                <!-- End Date-->
                <b-col md="6">
                  <InputField
                    id="end-date"
                    v-model="endDate"
                    label="End Date"
                    type="text"
                    readonly
                  />
                </b-col>
                <!--  End Date -->

                <!-- Fee -->
                <b-col md="6">
                  <SelectField
                    id="fee"
                    v-model="overdraftFormData.feeCodes"
                    :reduce="option => option.value"
                    label="Fee"
                    :options="feeOptions"
                    placeholder="Select Fee"
                    item="label"
                    multiple
                    :readonly="isReadonly"
                    class="select-fee"
                  />
                </b-col>
                <!-- Fee -->

                <!-- Interest Rate-->
                <b-col md="6">
                  <SelectField
                    id="interest"
                    v-model="interestId"
                    label="Profit Rate"
                    :reduce="option => option.value"
                    :options="interestOptions"
                    placeholder="Select"
                    error-name="Profit Rate"
                    rules="required"
                    item="label"
                    :set-selected="setInterestRate"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Interest Rate-->

                <!-- Interest Amount -->
                <b-col md="6">
                  <InputField
                    id="interest-rate"
                    v-model.number="overdraftFormData.interestAmount"
                    label="Profit Rate"
                    type="number"
                    readonly
                  />
                </b-col>
                <!-- Interest Amount -->
              </b-row>

              <h5 class="text-capitalize mb-3 mt-3">
                Security Pledge
              </h5>
              <b-row>
                <b-col md="6">
                  <SwitchButton
                    v-model="overdraftFormData.securityPledged"
                    label="Any Security Pledge?"
                    name="security-pledge"
                    :readonly="isReadonly"
                  />
                </b-col>
              </b-row>

              <b-row v-if="setSecurityPledge(overdraftFormData.securityPledged)">
                <!-- Type of security -->
                <b-col md="6">
                  <SelectField
                    id="interest"
                    v-model="overdraftFormData.securityType"
                    label="Type of security"
                    :reduce="option => option.value"
                    :options="securityTypesOptions"
                    placeholder="Select"
                    error-name="Type of security"
                    rules="required"
                    item="label"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Type of security -->

                <!-- Security valuation  -->
                <b-col md="6">
                  <InputNumberField
                    id="security-valuation"
                    v-model.number="overdraftFormData.securityValuation"
                    label="Security Valuation"
                    error-name="Security Valuation"
                    rules="required|positive"
                    :readonly="isReadonly"
                  />
                </b-col>
                <!-- Security valuation -->

                <!-- Detailed Description -->
                <b-col md="12">
                  <TextAreaField
                    id="detailed-description"
                    v-model="overdraftFormData.description"
                    label="Detailed Description"
                    placeholder="Enter description"
                    error-name="Detailed Desciption"
                    rules="required|max:150"
                    rows="5"
                    :on-input="setDescriptionCount"
                    :readonly="isReadonly"
                  />
                  <small :class="descriptionCountClass">{{ `${descriptionCount} / 150` }}</small>
                </b-col>
                <!-- Detailed Description -->
              </b-row>
              <div class="text-center mt-5">
                <Button
                  label="Save"
                  :loading="isLoading"
                  :disabled="isDisabled"
                  variant="primary"
                  size="lg"
                  @click="handleSubmit"
                />
              </div>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal"
      centered
      size="lg"
      title="Search Result"
      ok-only
      ok-title="Cancel"
      ok-variant="outline-secondary"
    >
      <b-table
        ref="customerListTable"
        :items="customerList"
        responsive
        :fields="tableHeaders"
        primary-key="id"
        show-empty
        selectable
        empty-text="No result found"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(customerID)="data">
          {{ data.value }}
        </template>

        <!-- Column: customerID -->
        <template #cell(accountName)="data">
          {{ data.value }}
        </template>
        <template #cell(accountType)="data">
          {{ data.value }}
        </template>
        <template #cell(accountStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BBadge,
  BModal, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, positive } from '@validations'
import { heightFade } from '@core/directives/animations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { mapActions } from 'vuex'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import { toBalance, toKobo, formatAmount } from '@/helpers/formatAmount'
import InputField from '../../../../forms/InputField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import getStatusColor from '../../../../../helpers/getStatusColor'
import { toYearWithDate, toDateWithYear } from '../../../../../helpers/formatDate'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import TextAreaField from '../../../../forms/TextAreaField.vue'
import getEndDate from '../../../../../helpers/getEndDate'
import { securityTypes } from '../../../../../helpers/data'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BBadge,
    BCol,
    Button,
    BTable,
    BModal,
    Alert,
    BForm,
    SwitchButton,
    ValidationObserver,
    InputField,
    InputNumberField,
    DatePickerField,
    SelectField,
    TablePagination,
    FullScreenSpinner,
    AppCollapse,
    AppCollapseItem,
    TextAreaField,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, toastAlert],
  data() {
    return {
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isLoading: false,
      isDisabled: false,
      isReadonly: false,
      positive,
      sortBy: 'accountName',
      showFormErrorAlert: false,
      showSpinner: false,
      showTable: false,
      required,
      isFlatAmount: false,
      isPercentage: false,
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        defaultDate: '',
        ariaDateFormat: 'd/m/Y',
      },
      endDate: '',
      timeout: null,
      securityTypesOptions: securityTypes,
      sortDesc: false,
      tableHeaders: [
        { key: 'customerID', sortable: true },
        { key: 'accountName', sortable: true },
        { key: 'accountType', sortable: true },
        { key: 'accountStatus', sortable: true },
      ],
      searchParams: {
        accountNumber: '',
        accountName: '',
        referenceNumber: '',
      },
      accountInfo: {
        accountName: '',
        productName: '',
        accountNumber: '',
      },
      customer: {
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
      },
      overdraftFormData: {
        accountNumber: '',
        limit: 0,
        tenure: 0,
        commencementDate: null,
        useDefaultFee: true,
        feeCode: '',
        feeAmount: 0,
        useDefaultInterest: true,
        interestCode: '',
        interestAmount: 0,
        securityPledged: false,
        securityType: '',
        securityValuation: 0,
        description: '',
        initiator: '',
        guarantorName: '',
        guarantorPhoneNumber: '',
      },
      interestOptions: [],
      feeOptions: [],
      maturityDate: null,
      getStatusColor,
      formOfLienOptions: [
        { label: 'Flat amount', value: 'FlatAmount' },
        { label: 'Percentage of balance', value: 'PercentageOfBalance' },
      ],
      filteredResult: [],
      customerList: [],
      feeCodes: [],
      interestId: '',
      feeDetails: [],
      interestDetails: [],
      actionType: 'save',
      descriptionCount: 0,
      permission: '',
    }
  },
  computed: {
    descriptionCountClass() {
      return this.descriptionCount > 150 ? 'text-danger' : ''
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
  mounted() {
    const { type } = this.$route.params
    this.actionType = type
    this.getPermission()
    this.fetchInterest()
    this.fetchFees()
    this.fetchOverdraftDetails()
  },
  methods: {
    ...mapActions({
      createOverdraft: 'account/createOverdraftAction',
      updateOverdraft: 'account/updateOverdraftAction',
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      getInterests: 'account/getInterestList',
      getInterest: 'account/getInterestById',
      getFees: 'account/getOverdraftFeeList',
      getFee: 'account/getOverdraftFee',
      getOverdraft: 'account/getOverdraft',
      getUserBalance: 'account/getCASABalanceAction',
    }),
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    setEndDate(dateStr) {
      const selectedDate = Array.isArray(dateStr) ? dateStr[0] : dateStr
      this.endDate = getEndDate(selectedDate, this.overdraftFormData.tenure)
    },
    setEndDateValue(noOfDays) {
      if (this.overdraftFormData.commencementDate) {
        this.endDate = getEndDate(this.overdraftFormData.commencementDate, noOfDays)
      }
    },
    setDescriptionCount(noOfText) {
      this.descriptionCount = noOfText.length
    },
    setSecurityPledge(selectedValue) {
      if (selectedValue === false) {
        this.overdraftFormData.securityType = ''
        this.overdraftFormData.securityValuation = 0
        this.overdraftFormData.description = ''
        return false
      }
      return true
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: this.permission,
          })
          const { data } = await response
          this.customerList = data.data
          this.totalCount = data.recordCount
          this.showSpinner = false
          this.$root.$emit('bv::show::modal', 'search-modal')
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      const customerInfo = items[0]
      if (customerInfo.accountStatus === 'Active') {
        this.accountInfo = {
          ...customerInfo,
        }
        const response = await this.getUserBalance({ accountNumber: customerInfo.accountNumber, permission: accountPermissions.CREATE_OVERDRAFT })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ledgerBalance: toBalance(data.ledgerBalance),
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
          }
        }
        this.overdraftFormData.accountNumber = customerInfo.accountNumber
        this.showCustomerInfo = true
        this.showSearchButton = true
        this.showBackButton = true
        this.$bvModal.hide('search-modal')
      } else {
        this.$bvModal.hide('search-modal')
        this.alertError({ text: 'Only active status accounts are valid for overdraft' })
      }
    },
    async overdraftAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const feeCodes = this.overdraftFormData.feeCodes ? this.overdraftFormData.feeCodes.map(item => {
          if (typeof item === 'string') {
            return { feeCode: item }
          }
          return { feeCode: item.value }
        }) : null
        if (this.overdraftFormData.maturityDate && this.overdraftFormData.accountName) {
          delete this.overdraftFormData.maturityDate
          delete this.overdraftFormData.accountName
        }
        const formData = {
          ...this.overdraftFormData,
          commencementDate: toYearWithDate(this.overdraftFormData.commencementDate),
          limit: toKobo(this.overdraftFormData.limit),
          feeCodes,
        }
        // eslint-disable-next-line no-constant-condition
        const response = (this.actionType === 'save' || this.actionType === 'add')
          ? await this.createOverdraft(formData)
          : await this.updateOverdraft(formData)

        const { status } = await response
        if (status === 200) {
          this.showCustomerInfo = false
          this.resetOverdraftFormData()
          this.resetSearchParams()
          this.timeout = setTimeout(() => {
            this.$router.push({ name: 'overdraft-list-nib' })
          }, 2000)
          this.alertSuccess({ text: `Your request to ${this.actionType} overdraft was successful` })
        }
      } catch (error) {
        this.isLoading = false
        this.isDisabled = false
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    handleSubmit() {
      this.$refs.overdraftRules.validate().then(async success => {
        if (success) {
          this.confirm(this.overdraftAction, { text: `Are you sure you want to ${this.actionType} Overdraft for ${this.accountInfo.accountName}` })
        }
      })
    },
    async fetchInterest() {
      try {
        const response = await this.getInterests({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.interestDetails = data.data
          this.interestOptions = data.data.filter(dataItem => dataItem.status === 'Active' && dataItem.type === 'Debit').map(item => ({ label: item.name, value: item.id }))
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    getPermission() {
      if (this.actionType === 'save' || this.actionType === 'add') {
        this.permission = accountPermissions.CREATE_OVERDRAFT
        return
      }
      if (this.actionType === 'edit') {
        this.permission = accountPermissions.MODIFY_OVERDRAFT
        return
      }
      this.permission = accountPermissions.VIEW_OVERDRAFT
    },
    async fetchFees() {
      try {
        const response = await this.getFees({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response

        if (status === 200 && data.data) {
          this.feeDetails = data.data
          this.feeOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.code }))
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async setFeeAmount(selectedValue) {
      try {
        const response = await this.getFee(selectedValue)
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.overdraftFormData.feeAmount = data.data.amount
          this.overdraftFormData.feeCode = data.data.code
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async setInterestRate(selectedValue) {
      try {
        const response = await this.getInterest({ id: selectedValue, permission: this.permission })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.overdraftFormData.interestAmount = data.data.rate
          this.overdraftFormData.interestCode = data.data.code
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async fetchOverdraftDetails() {
      try {
        const { id, type } = this.$route.params
        if (id !== undefined) {
          this.showCustomerInfo = true
          this.showSearchButton = true
          this.showBackButton = true
          this.showSpinner = true
          this.actionType = type
          this.isReadonly = type === 'view'
          this.isDisabled = type === 'view'
          await this.fetchFees()
          const response = await this.getOverdraft({ id, permission: this.permission })
          const { data, status } = response
          if (status === 200 && data.data) {
            this.showSpinner = false
            const interest = data.data.interestCode ? this.interestDetails.find(item => item.code === data.data.interestCode) : null
            const feeCodeArray = data.data.feeCodes ? data.data.feeCodes.map(item => item.feeCode) : []
            const feeCodes = this.feeDetails.filter(items => {
              if (feeCodeArray.includes(items.code)) {
                return items
              }
              return false
            }).map(item => ({ label: item.name, value: item.code }))
            this.customer = {
              ledgerBalance: toBalance(data.data.ledgerBalance),
              availableBalance: toBalance(data.data.availableBalance),
              withdrawableBalance: toBalance(data.data.withdrawableBalance),
            }
            this.overdraftFormData = {
              ...data.data,
              feeCodes,
              commencementDate: toDateWithYear(data.data.commencementDate),
              limit: data.data.limit === 0 ? data.data.limit.toString() : formatAmount(data.data.limit),
              interestAmount: data.data.interestAmount === 0 ? data.data.interestAmount.toString() : data.data.interestAmount,
            }
            if (interest !== null) {
              this.setInterestRate(interest.id)
              this.interestId = interest.name
            }
            this.endDate = toDateWithYear(data.data.maturityDate)
            this.descriptionCount = data.data.description ? data.data.description.length : ''
            const customerDetails = await this.searchCustomerAccount({
              search: { accountNumber: data.data.accountNumber },
              page: this.currentPage,
              limit: this.perPage,
              permission: this.permission,
            })
            const customerData = await customerDetails.data.data[0]
            this.accountInfo = {
              ...customerData,
            }
            const dropDownSelect = document.querySelector('.select-fee').querySelectorAll('.vs__selected')
            dropDownSelect.forEach(item => {
              item.classList.add('selected')
            })
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    resetOverdraftFormData() {
      this.overdraftFormData = { ...null }
    },
    resetSearchParams() {
      this.searchParams = { ...null }
      this.overdraftFormData = { ...null }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'overdraft-list-nib',
      })
    },
  },
}
</script>
<style scoped>
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
